import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Title from '../title/title';
import "./contact.css"

class Contact extends Component {
  titleContent = <p>If you are interested in a beautiful new, dynamic and functional website integrated with social media and optimised for the leading search engines, or other tech advice for your business or organisation please <a href="mailto:info@surfsidesolutions.com">email us (info@surfsidesolutions.com)</a> or give us a <a href="tel:+442843767321">call (+4428 4376 7321)</a>.</p>;
  render() {
    return (
      <div className="site-container" id="contact">
        <ReactCSSTransitionGroup
          transitionAppear={true}
          transitionAppearTimeout={600}
          transitionEnterTimeout={600}
          transitionLeaveTimeout={200}
          transitionName={'SlideUp'}
        >
          <div class="d-flex mapFlex">
            <Title className="title" name="Contact" content={this.titleContent} />
            <iframe className="map" src="https://www.google.com/maps/embed/v1/place?q=Surfside%20Solutions%2C%20Shore%20Road%2C%20Annalong%2C%20United%20Kingdom&amp;key=AIzaSyAnc6ZHskB5YEHjpPSmNKhMDppMd8BdRjk" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>
          </div>
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/components/contact/contact.js